/*
 |--------------------------------------------------------------------------
 | Lodash
 |--------------------------------------------------------------------------
 |
 | Lodash is a general purpose library which provides utility functions to
 | solve common programming tasks like manipulating strings, arrays and
 | objects using an elegant syntax while still being very performant.
 |
 */

window._ = require('lodash');

/*
 |--------------------------------------------------------------------------
 | Global jQuery Instance
 |--------------------------------------------------------------------------
 |
 | We'll load jQuery and the Bootstrap jQuery plugin which provides support
 | for JavaScript based Bootstrap features such as modals and tabs. This
 | code may be modified to fit the specific needs of your application.
 |
 */

window.$ = window.jQuery = require('jquery');

/*
 |--------------------------------------------------------------------------
 | Axios
 |--------------------------------------------------------------------------
 |
 | We'll load the axios HTTP library which allows us to easily issue requests
 | to our Laravel back-end. This library automatically handles sending the
 | CSRF token as a header based on the value of the "XSRF" token cookie.
 |
 */

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content;

/*
 |--------------------------------------------------------------------------
 | VueJS
 |--------------------------------------------------------------------------
 |
 | Vue is a modern JavaScript library for building interactive web interfaces
 | using reactive data binding and reusable components. Vue's API is clean
 | and simple, leaving you to focus on building your next great project.
 |
 */

window.Vue = require('vue').default;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

window.zESettings = {
    webWidget: {
        chat: {
            connectOnPageLoad: false,
        },
    },
};
